/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Motion, spring } from 'react-motion'

/**
 *     Import
 *     - Componernt
 */

/**
 *     Import
 *     - Images
 */
import { PercentageIcon } from '../../../../images/icons/Percentage/Percentage'

/**
 * Class for the Agency Summary in the Dashboard
 *
 * @export
 * @class AgencySummary
 * @extends {React.Component<any, any>}
 */
export default class AgencySummary extends React.Component<any, any> {

    /**
     * Creates an instance of AgencySummary.
     * @param {*} props
     * @memberof AgencySummary
     */
    constructor(props: any) {
        super(props)
        this.state = {
            selected: 'myStats',
            summary: {
                myStats: [
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                ],
                agencyStats: [
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                ],
                userStats: [
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                    {
                        premium: {
                            this: 0,
                            prev: 0,
                        },
                        conversion: {
                            this: 0,
                            prev: 0,
                        },
                        totalPolicies: 0,
                        inProgress: 0,
                        notTaken: 0,
                        lapsed: 0,
                    },
                ],
            },
        }
    }

    /**
     * Fetch the data at the begining
     *
     * @memberof AgencySummary
     */
    componentWillMount() {
        this.props.fetchAgencySummary()
    }

    /**
     * Will update the data if it receives a new one by props
     *
     * @param {*} nextProps
     * @memberof AgencySummary
     */
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.agencySummary.response &&
            (nextProps.agencySummary.response.summary !== this.state.summary)) {
            let newSummary = nextProps.agencySummary.response.summary
            this.setState({ summary: { ...this.state.summary, ...newSummary } })
        }

        if (nextProps.tabSelected !== this.state.selected) {
            this.setState({ selected: nextProps.tabSelected })
        }
    }

    render() {
        let premium = this.state.summary[this.state.selected]
        return (
            <div className="content">
                <div
                    className={`gross-premium ${(premium && premium[0].prev > 10000.00) ? `setHeight setPadding` : ``}`}
                >
                    <a>Gross written premium</a>
                    <div
                        className={`stats-font-set-24 
                        ${(premium && premium[0].premium.this > 10000.00 ? 'margin-r-35' : '')}`}
                    >
                        {
                            <Motion
                                defaultStyle={{ x: 0 }}
                                style={
                                    {
                                        x: spring(
                                            this.state.summary[this.state.selected]
                                            [this.props.summarytimePeriod].premium.this,
                                            { stiffness: 200 }
                                        ),
                                    }
                                }
                            >
                                {value => <h2>{(Math.round(value.x)).toLocaleString('en-GB', {
                                    style: 'currency',
                                    currency: 'GBP',
                                })}</h2>}
                            </Motion>
                        }
                        <a>This year</a>
                    </div>
                    <div className={'stats-font-set-24'}>
                        {
                            <Motion
                                defaultStyle={{ x: 0 }}
                                style={
                                    {
                                        x: spring(
                                            this.state.summary[this.state.selected]
                                            [this.props.summarytimePeriod].premium.prev,
                                            { stiffness: 200 }
                                        ),
                                    }
                                }
                            >
                                {value => <h2>{(Math.round(value.x)).toLocaleString('en-GB', {
                                    style: 'currency',
                                    currency: 'GBP',
                                })}</h2>}
                            </Motion>
                        }
                        <a>Previous year</a>
                    </div>
                </div>
                <div className={`conversion-rate ${(premium && premium[0].prev > 10000.00) ? `setHeight` : ``}`}>
                    <a className={(premium && premium[0].prev > 10000.00) ? `margin-t-40` : ``}>
                        Conversion rate
                    </a>
                    <div>
                        <Motion
                            defaultStyle={{ x: 0 }}
                            style={
                                {
                                    x: spring(
                                        this.state.summary[this.state.selected]
                                        [this.props.summarytimePeriod].conversion.this,
                                        { stiffness: 60 }
                                    ),
                                }
                            }
                        >
                            {value => <PercentageIcon percentageFilled={value.x} />}
                        </Motion>
                        <div className="conversion-rate__percentage stats-font-set-24">
                            {
                                <Motion
                                    defaultStyle={{ x: 0 }}
                                    style={
                                        {
                                            x: spring(
                                                this.state.summary[this.state.selected]
                                                [this.props.summarytimePeriod].conversion.this,
                                                { stiffness: 60 }
                                            ),
                                        }
                                    }
                                >
                                    {value => <h2>{Math.round(value.x)}%</h2>}
                                </Motion>
                            }
                            <a>This year</a>
                        </div>
                    </div>
                    <div>
                        <Motion
                            defaultStyle={{ x: 0 }}
                            style={
                                {
                                    x: spring(
                                        this.state.summary[this.state.selected]
                                        [this.props.summarytimePeriod].conversion.prev,
                                        { stiffness: 60 }
                                    ),
                                }
                            }
                        >
                            {value => <PercentageIcon percentageFilled={value.x} />}
                        </Motion>
                        <div className="conversion-rate__percentage stats-font-set-24">
                            {
                                <Motion
                                    defaultStyle={{ x: 0 }}
                                    style={
                                        {
                                            x: spring(
                                                this.state.summary[this.state.selected]
                                                [this.props.summarytimePeriod].conversion.prev,
                                                { stiffness: 60 }
                                            ),
                                        }
                                    }
                                >
                                    {value => <h2>{Math.round(value.x)}%</h2>}
                                </Motion>
                            }
                            <a>Previous year</a>
                        </div>
                    </div>
                </div>
                <div className="total-numbers">
                    <div>
                        <a>Total policies</a>
                        {
                            <Motion
                                defaultStyle={{ x: 0 }}
                                style={
                                    {
                                        x: spring(
                                            this.state.summary[this.state.selected]
                                            [this.props.summarytimePeriod].totalPolicies,
                                            { stiffness: 100 }
                                        ),
                                    }
                                }
                            >
                                {value => <h2>{Math.round(value.x)}</h2>}
                            </Motion>
                        }
                    </div>
                    <div>
                        <a>Total quotes</a>
                        {
                            <Motion
                                defaultStyle={{ x: 0 }}
                                style={
                                    {
                                        x: spring(
                                            this.state.summary[this.state.selected]
                                            [this.props.summarytimePeriod].inProgress,
                                            { stiffness: 100 }
                                        ),
                                    }
                                }
                            >
                                {value => <h2>{Math.round(value.x)}</h2>}
                            </Motion>
                        }
                    </div>
                </div>
                <div className="total-numbers">
                    <div>
                        <a>Not taken up</a>
                        {
                            <Motion
                                defaultStyle={{ x: 0 }}
                                style={
                                    {
                                        x: spring(
                                            this.state.summary[this.state.selected]
                                            [this.props.summarytimePeriod].notTaken,
                                            { stiffness: 100 }
                                        ),
                                    }
                                }
                            >
                                {value => <h2>{Math.round(value.x)}</h2>}
                            </Motion>
                        }
                    </div>
                    <div>
                        <a>Lapsed</a>
                        {
                            <Motion
                                defaultStyle={{ x: 0 }}
                                style={
                                    {
                                        x: spring(
                                            this.state.summary[this.state.selected]
                                            [this.props.summarytimePeriod].lapsed,
                                            { stiffness: 100 }
                                        ),
                                    }
                                }
                            >
                                {value => <h2>{Math.round(value.x)}</h2>}
                            </Motion>
                        }
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Dashboard/components/AgencySummary.tsx